import _get from "lodash/get";

import Ratings from "@components/Ratings";
import { productHelper, resizeImage } from "@lib/helpers";
import Link from "next/link";
import Price from "@components/Price";
import AddToCart from "@containers/Catalog/Actions/AddToCart";

// TODO: We should use a standard product card

const ProductsCompareTableProductCard = ({ product, onClick }) => {
  const { isResealed } = productHelper(product);

  return (
    <div className="relative">
      <div className="relative mt-0 lg:pt-12 pt-6">
        <Link href={`/${product.url_key}/cpd/${product.sku}/`}>
          <a title={product.name} onClick={() => onClick(product)}>
            <img
              src={resizeImage(product.thumbnail, "300x300")}
              alt={product.name}
              className="mx-auto sm:w-120px mb-[36px]"
            />
          </a>
        </Link>
      </div>

      <h2>
        <Link href={`/${product.url_key}/cpd/${product.sku}/`}>
          <a
            className="Product-name truncate-3-lines text-sm min-h-[70px]"
            title={product.name}
            onClick={() => onClick(product)}
          >
            {isResealed && <span>Resigilat:</span>}
            {product.name}
          </a>
        </Link>
      </h2>

      <div className="h-[20px]">
        <Ratings
          reviewsCount={_get(product, "reviews_count", 0)}
          ratingSummary={_get(product, "reviews_value", null)}
          displayReviewsNo={true}
          productUrl={`/${product.url_key}/cpd/${product.sku}/`}
        />
      </div>

      <div className="flex items-end min-h-[66px]">
        <Price
          productId={parseInt(product.id)}
          price={product.price}
          regularPrice={product.regular_price}
          formatted={true}
          discountType={product.discount_type}
          size="smaller"
        />
      </div>

      <AddToCart product={product} isCatalog />
    </div>
  );
};

export default ProductsCompareTableProductCard;
